import { c as _c } from "react/compiler-runtime";
import { MobileDisclosure } from "./mobile-disclosure";
import { MobileLeafLink } from "./mobile-leaf-link";
import { isNavGroup, type NavItem } from "./navigation-data";
type MobileNavigationProps = {
  items: readonly NavItem[];
  pathname: string;
  onNavigate: () => void;
};
export function MobileNavigation(t0) {
  const $ = _c(9);
  const {
    items,
    pathname,
    onNavigate
  } = t0;
  let t1;
  if ($[0] !== items || $[1] !== onNavigate || $[2] !== pathname) {
    let t2;
    if ($[4] !== onNavigate || $[5] !== pathname) {
      t2 = item => isNavGroup(item) ? <MobileDisclosure key={item.label} group={item} depth={0} pathname={pathname} onNavigate={onNavigate} /> : <li key={item.href}><MobileLeafLink item={item} depth={0} pathname={pathname} onNavigate={onNavigate} /></li>;
      $[4] = onNavigate;
      $[5] = pathname;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = items.map(t2);
    $[0] = items;
    $[1] = onNavigate;
    $[2] = pathname;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <ul className="grid gap-1">{t1}</ul>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}